import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../_helpers/config';

function ManageSubscription({ user, plans, subs, onUpdate, closeModal, loggedInUser }) {
  const [validUntil, setValidUntil] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [availablePlans, setAvailablePlans] = useState(plans || []);
  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedSub, setSelectedSub] = useState(user.planId);
  
  //const token = sessionStorage.getItem("jwtToken");
  const getSubsPlanById = (planId) => {
  if (!planId || !plans.length) {
    return <span className="plan-chip plan-no-plan">
          No Plan
        </span>;
  }

  // Find the subscription with matching _id
  const sub = subs.find(s => s._id === planId);
  if (!sub) {
    return   <span className="plan-chip plan-unknown">
          Unknown Plan
        </span>;
  }

  // Find the associated plan and attach it
  const pl = plans.find(p => p.id === sub.planId);
  if (pl) {
    return  <span className={`plan-chip`}>{`${pl.planName}, ${sub.frequency},  ${sub.currency} ${sub.frequencyPrice}`}</span>;
  }
  
  };  

  // Format date for the date picker when user already has a plan
  useEffect(() => {
    selectedSub && updateValidUntilDate(subs.find(s => s._id == selectedSub).frequency);
  }, []);

  

  
  // Format duration label for display
  const formatDurationLabel = (durationCode) => {
    if (!durationCode) return '';
    switch(durationCode) {
      case 'monthly': return 'Monthly';
      case 'quarterly': return 'Quarterly';
      case 'half-yearly': return 'Half-Yearly';
      case 'yearly': return 'Yearly';
      default: return durationCode;
    }
  };
  // Handle frequency selection
  const handleSubsChange = (e) => {
    const subId = e.target.value;
    setSelectedSub(subId);
    updateValidUntilDate(subs.find(s => s._id == subId).frequency);
  };
  
  // Update valid until date based on selected frequency
  const updateValidUntilDate = (frequency) => {
    if (!frequency) return;
    
    const date = new Date();
    
    // Use exact day counts for standard durations
    switch(frequency) {
      case 'monthly':
        date.setDate(date.getDate() + 30);
        break;
      case 'quarterly':
        date.setDate(date.getDate() + 90);
        break;
      case 'half-yearly':
        date.setDate(date.getDate() + 180);
        break;
      case 'yearly':
        date.setDate(date.getDate() + 365);
        break;
      default:
        // Try to extract duration from string (e.g., "3 month", "1 year")
        const durationMatch = frequency.match(/(\d+)\s*(\w+)/i);
        if (durationMatch) {
          const value = parseInt(durationMatch[1]) || 1;
          const unit = durationMatch[2].toLowerCase();
          
          if (unit.includes('month')) {
            date.setDate(date.getDate() + (value * 30));
          } else if (unit.includes('year')) {
            date.setDate(date.getDate() + (value * 365));
          } else if (unit.includes('day')) {
            date.setDate(date.getDate() + value);
          } else if (unit.includes('week')) {
            date.setDate(date.getDate() + (value * 7));
          }
        } else {
          // Default to 30 days
          date.setDate(date.getDate() + 30);
        }
    }
    
    // Format the date for the input
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
     setValidUntil(`${year}-${month}-${day}`);
  };
  
  // Format subscription price for display
  const formatPrice = (price) => {
    if (!price) return '';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: user.currency,
      maximumFractionDigits: 0
    }).format(price);
  };
  

  
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    onUpdate(selectedSub, validUntil);
  };

  return (
    <div className="subscription-manager">
      <form className="subscription-form" onSubmit={handleSubmit}>
        <div className="subscription-form-row">
          <div className="subscription-form-group">
            <label className="subscription-form-label">Subscription Plan <a target="_blank" href={`https://${window.location.href.split('.')[1]}.${window.location.href.split('.')[2]}`} >Know About Plans</a></label>
            <select 
              className="subscription-form-select"
              value={selectedSub} 
              onChange={handleSubsChange}
              required
            >
              <option value="">-- Select a Subscription --</option>
              {subs.map(sub => (
                <option key={sub._id} value={sub._id}>
                  {getSubsPlanById(sub._id)}
                </option>
              ))}
            </select>
          </div>
        
        </div>
        
        <div className="subscription-form-row">
          <div className="subscription-form-group">
            <label className="subscription-form-label">Plan Validity</label>
            {loggedInUser && loggedInUser.role.toUpperCase() == 'SUPER-ADMIN' ? <input 
              type="date" 
              className="subscription-form-date-input"
              value={validUntil} 
              onChange={(e) => setValidUntil(e.target.value)}
              required
            />: <h3>{validUntil}</h3>}
            <div className="subscription-date-helper">
              Subscription will be active until this date
            </div>
          </div>
        </div>
        
        <div className="subscription-form-actions">
           <div className="footer-btn-holder">
                <span
                  onClick={closeModal}
                  className="btn-custom-cancel"
                >
                  Cancel
                </span>
                <button
                 type="submit" 
                  disabled={isSubmitting || !selectedSub}
                  className="btn-custom-primary"
                >
                  {isSubmitting ? (
                  <>
                <div className="subscription-loading-spinner"></div>
                Updating...
                 </>
                  ) : 
              (loggedInUser && loggedInUser.role.toUpperCase() == 'SUPER-ADMIN' ?<>
                Update Subscription
              </>:<>
                Pay Now
              </>)
            }
                </button>
              </div>
        </div>
      </form>
    </div>
  );
}

export default ManageSubscription;